document.addEventListener('DOMContentLoaded', function () {

  /* ── SCROLL: sticky mobile filter bar (throttled via rAF, passive, cached) ── */
  let _mfTicking = false;
  let _mfStuck = false;
  const _mfList = document.querySelectorAll('.mobile-filters');
  if (_mfList.length) {
    window.addEventListener('scroll', function () {
      if (_mfTicking) return;
      _mfTicking = true;
      requestAnimationFrame(function () {
        _mfTicking = false;
        const stuck = window.scrollY >= 2;
        if (stuck === _mfStuck) return;
        _mfStuck = stuck;
        for (let i = 0; i < _mfList.length; i++) {
          _mfList[i].classList.toggle('stickiy-filter', stuck);
        }
      });
    }, { passive: true });
  }

  /* ── SCROLL: sticky header (throttled via rAF, passive) ── */
  let _hdrTicking = false;
  let _hdrStuck = false;
  const _header = document.querySelector('.header');
  const _body = document.body;
  window.addEventListener('scroll', function () {
    if (_hdrTicking) return;
    _hdrTicking = true;
    requestAnimationFrame(function () {
      _hdrTicking = false;
      const stuck = window.scrollY > 50;
      if (stuck === _hdrStuck) return;
      _hdrStuck = stuck;
      if (stuck) {
        _header && _header.classList.add('stuck');
        _body.classList.add('stickybar-body');
      } else {
        _header && _header.classList.remove('stuck');
        _body.classList.remove('stickybar-body');
      }
    });
  }, { passive: true });

  /* ── ROTATE ICON (state-tracked: no full-DOM query per click) ── */
  let _rotateIcon = null;
  let _rotateMeta = null;
  function _closeRotate() {
    if (_rotateMeta) _rotateMeta.style.display = 'none';
    if (_rotateIcon) _rotateIcon.classList.remove('rotate');
    _rotateMeta = null;
    _rotateIcon = null;
  }
  document.addEventListener('click', function (e) {
    const icon = e.target.closest('span.roatate-icon');
    if (icon) {
      const wasActive = icon === _rotateIcon;
      _closeRotate();
      if (!wasActive) {
        const parent = icon.closest('.icon-with-title');
        const meta = parent && parent.querySelector('.product-meta');
        if (meta) {
          icon.classList.add('rotate');
          meta.style.display = 'block';
          _rotateIcon = icon;
          _rotateMeta = meta;
        }
      }
      return;
    }
    if (!e.target.closest('.product-meta')) {
      _closeRotate();
    }
  });

  /* ── VIEW TOGGLE (collection page) ── */
  var _collGrid = document.querySelector('.collection__products.collection__infinite-container');
  if (_collGrid) {
    _collGrid.classList.remove('list-view-wrap');
    _collGrid.classList.add('grid-view-wrap');
  }
  var _gridBtn = document.getElementById('grid-view-btn');
  var _listBtn = document.getElementById('list-view-btn');
  if (_gridBtn) _gridBtn.classList.add('active');

  if (_gridBtn) {
    _gridBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (_collGrid) { _collGrid.classList.remove('list-view-wrap'); _collGrid.classList.add('grid-view-wrap'); }
      localStorage.setItem('viewPreference', 'grid-view-wrap');
    });
  }
  if (_listBtn) {
    _listBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (_collGrid) { _collGrid.classList.remove('grid-view-wrap'); _collGrid.classList.add('list-view-wrap'); }
      localStorage.setItem('viewPreference', 'list-view-wrap');
    });
  }
  /* Delegated view-toggle active-state (one listener, scoped query per click) */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.view-toggle button');
    if (!btn) return;
    const wrap = btn.closest('.view-toggle');
    if (wrap) {
      const siblings = wrap.querySelectorAll('button');
      for (let i = 0; i < siblings.length; i++) siblings[i].classList.remove('active');
    }
    btn.classList.add('active');
  });

  /* ── QUICK SWATCHES: instant tap — no 300 ms browser delay ──────────────────
     pointerdown fires the moment a finger touches, before the browser decides
     whether this is a tap, double-tap, or scroll.  passive:true lets the
     browser begin scroll handling without waiting for this handler to return.
  ──────────────────────────────────────────────────────────────────────────── */
  document.addEventListener('pointerdown', function (e) {
    var swatch = e.target.closest('span.custom-quick-search, span.custom-quick-image');
    if (!swatch || !swatch.dataset.img) return;
    var src = swatch.dataset.img;

    // Instant selected-ring feedback (kept synchronous)
    var group = swatch.closest('.custom-quick-swatches');
    if (group) {
      var groupSwatches = group.querySelectorAll('span.custom-quick-search, span.custom-quick-image');
      for (var i = 0; i < groupSwatches.length; i++) groupSwatches[i].classList.remove('selected');
      swatch.classList.add('selected');
    }

    // Image swap deferred to next frame — heavy DOM writes don't block the tap response
    var card = swatch.closest('.product-item__inner');
    if (card) {
      requestAnimationFrame(function () {
        var imgs = card.querySelectorAll('.product-item__image img');
        for (var j = 0; j < imgs.length; j++) {
          var img = imgs[j];
          img.src    = src;
          img.srcset = src;
          if (img.dataset.src    !== undefined) img.dataset.src    = src;
          if (img.dataset.srcset !== undefined) img.dataset.srcset = src;
          img.classList.remove('lazyload', 'lazyloading', 'b-lazy');
          img.classList.add('lazyloaded');
        }
      });
    }
  }, { passive: true });

  // Hover preview in search dropdown (desktop) — rAF-throttled
  var _hoverRaf = false;
  var _hoverSwatch = null;
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('span.custom-quick-image');
    if (!swatch || !swatch.dataset.img) return;
    _hoverSwatch = swatch;
    if (_hoverRaf) return;
    _hoverRaf = true;
    requestAnimationFrame(function () {
      _hoverRaf = false;
      var s = _hoverSwatch;
      if (!s) return;
      var result = s.closest('.quick-search__result');
      if (!result) return;
      var img = result.querySelector('.quick-search__result-image-wrapper img');
      if (img) { img.src = s.dataset.img; img.srcset = s.dataset.img; }
    });
  });

  // Preload during idle on product/search pages; collection swatches load on demand.
  // (skipped on homepage to avoid loading dozens of unused variant images)
  var _tpl = document.body.className;
  if (_tpl.indexOf('template-product')    !== -1 ||
      _tpl.indexOf('template-search')     !== -1) {
    function _preloadSwatchImages() {
      document.querySelectorAll('[data-img]').forEach(function (el) {
        var src = el.dataset.img;
        if (!src) return;
        var link = document.createElement('link');
        link.rel  = 'preload';
        link.as   = 'image';
        link.href = src;
        link.setAttribute('fetchpriority', 'low');
        document.head.appendChild(link);
      });
    }
    if (window.requestIdleCallback) {
      requestIdleCallback(_preloadSwatchImages, { timeout: 1000 });
    } else {
      setTimeout(_preloadSwatchImages, 200);
    }
  }

  /* ── FILTER: show more / show less ── */
  document.querySelectorAll('ul.filter-drawer__list').forEach(function (list) {
    var items = list.querySelectorAll('li');
    if (items.length > 4) {
      items.forEach(function (li, i) {
        if (i >= 3) { li.style.display = 'none'; li.classList.add('toggleable'); }
      });
      var btn = document.createElement('li');
      btn.textContent = 'Show More..';
      btn.className   = 'more';
      list.appendChild(btn);
    }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.more, .less');
    if (!btn) return;
    var list  = btn.closest('ul.filter-drawer__list');
    var items = list.querySelectorAll('.toggleable');
    var isMore = btn.classList.contains('more');
    items.forEach(function (li) { li.style.display = isMore ? 'list-item' : 'none'; });
    btn.textContent = isMore ? 'Show Less..' : 'Show More..';
    btn.classList.toggle('more', !isMore);
    btn.classList.toggle('less', isMore);
  });

  /* ── SMOOTH SCROLL (cached header-height; re-read on resize, not per click) ── */
  var _headerH = 0;
  function _readHeaderH() {
    _headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--height-header')) || 0;
  }
  _readHeaderH();
  window.addEventListener('resize', _readHeaderH, { passive: true });
  function _smoothScrollTo(selector) {
    var el = document.querySelector(selector);
    if (!el) return;
    window.scrollTo({ top: el.offsetTop - _headerH, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-rating.customscroll'))   { e.preventDefault(); _smoothScrollTo('[data-section-type="apps"]'); }
    if (e.target.closest('.child_content.effing_click'))    { e.preventDefault(); _smoothScrollTo('.product_size_fit_block'); }
    if (e.target.closest('.child_content.built_click'))     { e.preventDefault(); _smoothScrollTo('.product_block_featured_block'); }
  });

  /* ── DESKTOP SLIDE SECTION ── */
  var _dss = document.querySelector('.desktop-slide-section');
  if (_dss) _dss.style.display = 'block';

  /* ── HEADWEAR SCROLLING FALLBACK ── */
  function _ensureScrolling() {
    var bbsList = document.querySelector('.bbs-nav-list.bbs-slide');
    if (bbsList && !bbsList.classList.contains('slick-initialized')) {
      // Add native scrolling if Slick hasn't initialized
      bbsList.style.display = 'flex';
      bbsList.style.overflowX = 'auto';
      bbsList.style.scrollBehavior = 'smooth';
      bbsList.style.webkitOverflowScrolling = 'touch';
      
      var items = bbsList.querySelectorAll('.bbs-nav-itemm');
      items.forEach(function(item) {
        item.style.flex = '0 0 auto';
        item.style.marginRight = '10px';
      });
    }
  }

  // Check for scrolling after a short delay
  setTimeout(_ensureScrolling, 1000);

  /* ── SLICK SLIDERS (jQuery required) ── */
  function _initSlick() {
    if (typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;
    var $ = jQuery;

    if ($('.custom-slides').length) {
      $('.custom-slides').slick({
        infinite: true, slidesToShow: 1, slidesToScroll: 1,
        autoplay: true, autoplaySpeed: 5000, arrows: true,
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>'
      }).css('opacity', 1);
    }

    if (window.innerWidth <= 767 && $('.images-boxes').length) {
      $('.images-boxes').slick({
        infinite: true, dots: true, slidesToShow: 1, slidesToScroll: 1,
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>'
      });
    }

    // Initialize browse-by-style slider for all screen sizes
    if ($('.bbs-slide').length) {
      $('.bbs-slide').slick({
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          }
        ]
      });
    }
  }

  // Run now if jQuery + slick are already loaded, else wait for first interaction
  if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
    _initSlick();
  } else {
    var _slickBound = false;
    function _slickOnInteract() {
      if (_slickBound) return;
      _slickBound = true;
      _initSlick();
    }
    ['scroll', 'mousemove', 'touchstart', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, _slickOnInteract, { once: true, passive: true });
    });
  }

  /* ── PRODUCT PAGE: scroll-to links (vanilla, no jQuery dependency) ── */
  function _scrollToTarget(sel) {
    var target = document.querySelector(sel);
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - _headerH;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  document.querySelectorAll('.product-rating.customscroll').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      _scrollToTarget('[data-section-type="apps"]');
    });
  });
  document.addEventListener('click', function (e) {
    var effing = e.target.closest('.child_content.effing_click');
    var built  = e.target.closest('.child_content.built_click');
    if (effing) {
      e.preventDefault();
      _scrollToTarget('.product_size_fit_block');
    } else if (built) {
      e.preventDefault();
      _scrollToTarget('.product_block_featured_block');
    }
  });

});
